import React from 'react';
import styles from './Platform.module.scss';
import api from "../../../helpers/api";

import {$t} from '../../../helpers/translator';
import PlatformUsageGraph from "../../../components/clinic/PlatformUsageGraph/PlatformUsageGraph";
import TreatmentsTable from "../../../components/TreatmentsTable/TreatmentsTable";
import ErrorsTable from "../../../components/ErrorsTable/ErrorsTable";
import ErrorsGraph from "../../../components/ErrorsGraph/ErrorsGraph";
import ApplicatorsGrid from "../../../components/ApplicatorsGrid/ApplicatorsGrid";
import PlatformDetails from "../../../components/PlatformDetails/PlatformDetails";
import Loader from "components/miscellaneous/Loader/Loader";


class ChainPlatform extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.match.params.id ? this.props.match.params.id : null,
            platformExists: false,
            callEnded: false
          };
    }

    async componentDidMount() {
        try {
          let res = await api.get(`/platform/${this.state.id}/exists`);
          if(res && res.data && res.data.data && res.data.data.exists) {
            this.setState({platformExists: true})
          } else {
            this.setState({platformExists: false})
          }
          this.setState({callEnded: true})
        } catch (e) {
            console.error(e)
        } finally {
            
        }
      }

    render() {
        return (
            <div>
            {this.state.platformExists ?
            <div className={`${styles['container']}`}>

                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <PlatformDetails platformId={this.state.id} userType={3}/>
                    </div>
                </div>

                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <ApplicatorsGrid userType={3} platformId={this.state.id} perPage={5} header={$t('global.machines.platformApplicators')}/>
                    </div>
                </div>

                <div className={'alma-box'}>
                    <div className={'alma-box-header'}>
                        <div><h3>{$t('global.machines.platformUsage')}</h3></div>
                    </div>
                    <PlatformUsageGraph platformId={this.state.id}/>
                </div>

                <TreatmentsTable userType={3} platformId={this.state.id} header={$t('global.treatments.platformTreatments')}/>

                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <ErrorsTable platformId={this.state.id} header={$t('global.service.platformErrors')}/>
                    </div>
                </div>

                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <ErrorsGraph platformId={this.state.id} header={$t('global.service.platformErrorsGraph')}/>
                    </div>
                </div>
            </div>
                      :
                      <div>
                          {this.state.callEnded ? 
                              <div>Platform not found</div>
                              :
                              <div><Loader /></div>
                          }
                      </div>
            }
                  </div>
        );
    }
}

export default ChainPlatform;
